/**
 * @typedef {
 * 'preTest' | 'Teach' | 'postTest'
 * } PtpMode
 */

/**
 * @typedef {'baseline' | 'active' | 'maintenance'} ActiveProgramStatus
 */

export const PTP_MODES = {
  PRE_TEST: 'preTest',
  TEACH: 'teach',
  POST_TEST: 'postTest',
};

export const PROGRAM_SCOPES = {
  LIBRARY: 'Library',
  CLIENT: 'Programs',
};

export const PROGRAM_DETAILS_VIEWS = {
  PROGRAM: 'program',
  TARGET: 'target',
};

export const ACTIVE_PROGRAM_STATUSES = ['baseline', 'active', 'maintenance'];

export const PROGRAM_STATUSES = /** @type {const} */ ({
  ACTIVE: 'active',
  BASELINE: 'baseline',
  CLOSED: 'closed',
  DISCONTINUED: 'discontinued',
  HOLD: 'hold',
  MAINTENANCE: 'maintenance',
  WAITING: 'waiting',
});

/** @typedef {typeof PROGRAM_STATUSES[keyof typeof PROGRAM_STATUSES]} ProgramStatus */

/** `program.clientType` — whether a program is run for a client or measures the staff member. */
export const PROGRAM_CLIENT_TYPES = {
  CLIENT: 'client',
  STAFF: 'staff',
};

export const PROGRAM_TYPE_SKILL_ACQUISITION = 'simple';

export const PROGRAM_TYPE_BEHAVIOR_TRACKING = 'behaviorTracking';

export const BEHAVIOR_TRACKING_ICON = 'radar';

/**
 * Program types that behave identically to Skill Acquisition (`simple`). Behavior Tracking
 * is a deliberate clone of it, so anything branching on `simple` alone silently excludes the new type.
 */
export const SIMPLE_LIKE_PROGRAM_TYPES = [PROGRAM_TYPE_SKILL_ACQUISITION, PROGRAM_TYPE_BEHAVIOR_TRACKING];

/**
 * Score for a behavior occurrence on a target with no prompt levels, which is recorded as a plain
 * count. Frequency counts only entries scoring above zero — in `runWorkflows` and the SQL metric
 * views alike — so an unscored count would never be counted.
 */
export const BEHAVIOR_OCCURRENCE_SCORE_VALUE = 100;

export const RETHINK_PROGRAM_NAMES = {
  BEHAVIOR_REDUCTION: 'Behavior Reduction',
};

export const PROGRAM_DATA_TYPES = {
  INCIDENTS: 'incidents',
};

export const PROGRAM_TYPES = {
  ASR: 'asr',
  BEHAVIOUR: 'behaviour',
  DURATION: 'duration',
  ESDM: 'esdm',
  FREQUENCY: 'frequency',
  INSTRUCTIONS: 'instructions',
  INTERVAL: 'interval',
  PTP: 'ptp',
  SBT: 'sbt',
  SET: 'set',
  SIMPLE: 'simple',
  TASK_ANALYSIS: 'taskAnalysis',
};
export const PLANNED_MASTERY_QUANTITY_MIN = 1;
export const PLANNED_MASTERY_QUANTITY_MAX = 50;
